import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const getSessionId = () => {
  let id = sessionStorage.getItem("nsc_session_id");
  if (!id) {
    id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem("nsc_session_id", id);
  }
  return id;
};

export const track = (event, metadata = {}, page) => {
  axios
    .post(`${API}/events`, {
      event,
      page: page || window.location.pathname,
      metadata,
      session_id: getSessionId(),
    })
    .catch(() => {});
};

export const api = {
  packages: () => axios.get(`${API}/packages`).then((r) => r.data.packages),
  articles: () => axios.get(`${API}/articles`).then((r) => r.data.articles),
  article: (slug) => axios.get(`${API}/articles/${slug}`).then((r) => r.data),
  faqs: () => axios.get(`${API}/faqs`).then((r) => r.data.faqs),
  testimonials: () => axios.get(`${API}/testimonials`).then((r) => r.data.testimonials),
  assessmentConfig: () => axios.get(`${API}/assessment-config`).then((r) => r.data),
  submitAssessment: (payload) => axios.post(`${API}/assessments`, payload).then((r) => r.data),
  captureEmail: (id, payload) => axios.post(`${API}/assessments/${id}/email`, payload).then((r) => r.data),
  bookingLead: (payload) => axios.post(`${API}/booking-leads`, payload).then((r) => r.data),
  checkout: (payload) => axios.post(`${API}/payments/checkout`, payload).then((r) => r.data),
  paymentStatus: (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data),
};
